module.exports = __webpack_public_path__ + "img/FieldCardPlaceholder.20361830.png";